<template>
  <div class="ArticleFooter">
    <hr class="ArticleFooter__horizontal-rule">

    <div class="ArticleFooter__content">
      <LinkDirectional
        v-if="link.text && link.slug"
        class="ArticleFooter__category-link"
        :text="link.text"
        :to="link.slug"
        theme="black"
      />

      <ShareLinkGroup
        v-bind="$attrs"
        class="ArticleFooter__share-link-group"
      />

      <RelatedContent
        v-if="articles.length"
        :articles="articles"
        :class="$b('related-content')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleFooter',

  inheritAttrs: false,

  props: {
    link: {
      type: Object,
      default: () => ({})
    },

    articles: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="postcss">
.ArticleFooter {
  @apply pb-lg lg:pb-xxl;

  @screen lg {
    flex-grow: 1;
  }
}

.ArticleFooter__copy {
  --margin-bottom: 60px;

  @screen sm {
    --margin-bottom: 80px;
  }

  max-width: calc(752 / 24 * 1em);
  margin-bottom: var(--margin-bottom);
}

.ArticleFooter__horizontal-rule {
  @apply border-grey
    mb-sm;

  margin-top: 0;

  @screen lg {
    margin-bottom: theme('spacing.md');
  }
}

.ArticleFooter__content {
  @apply flex
    flex-col
    lg:flex-row
    lg:justify-between;
}

.ArticleFooter__category-link {
  @apply lgMax:mb-sm;

  margin-left: calc(0px - theme('spacing.xxxs'));
}

.ArticleFooter__share-link-group {
  @screen sm {
    right: calc(0px - theme('spacing.xxs'));
  }
}

.ArticleFooter__related-content {
  @apply mt-md md:hidden;
}
</style>
